import { jsonMember, jsonObject } from 'typedjson';
import { ShippingMethodPropertyMetadataCode } from '../../enums/shipping-method-property-metadata-code';

@jsonObject
export class ShippingMethodPropertyMetadataResponse {
  @jsonMember(String)
  public readonly code!: ShippingMethodPropertyMetadataCode;

  @jsonMember(String)
  public readonly value!: string;
}
